import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import Helmet from 'react-helmet'

import { IS_WEB, IS_PROD, IS_SANDBOX } from '../../config/'

import Icon from '../components/Icon'
import Link from '../components/Link'
import PageSection from '../components/PageSection'
import EmailCollection from '../components/EmailCollection'

import { showModal } from '../../reducers/modal'

import { trackEvent } from '../../utils/tracking'
import { parseQueryParams } from '../../utils/url'

const emailCollectionConfig = {
  // https://us7.admin.mailchimp.com/lists/settings/defaults?id=392061
  mailchimpListId: '0018c3bfae',
  mailchimpStatus: 'subscribed'
}

const TITLE_QUERY_PARAM_KEY = 't'
const PRIVACY_QUERY_PARAM_KEY = 'p'
const DEFAULT_TITLE = 'The Home Assistant That Doesn’t Listen'

const CURRENT_YEAR = new Date().getFullYear()

function toTitleCase (string) {
  return string
    .split(' ')
    .map(w => w.slice(0, 1).toUpperCase() + w.slice(1))
    .join(' ')
}

export const SnipsHomeCampaignPage = ({ showModal }) => {
  const {
    [TITLE_QUERY_PARAM_KEY]: titleQueryParam,
    [PRIVACY_QUERY_PARAM_KEY]: privacyQueryParam
  } = IS_WEB ? parseQueryParams(window.location.search) : {}
  const showPrivacySection =
    privacyQueryParam === 'true' || privacyQueryParam === '1'
  // NOTE: server render w an opacity hidden title,
  // since title is dynamic via query param, and not known server side.
  // Cannot just be '', because then text node collapses in layout.
  const title = titleQueryParam
    ? toTitleCase(titleQueryParam.replace(/-/g, ' '))
    : DEFAULT_TITLE

  const heroClass = classnames(
    {
      mb4: !showPrivacySection
    },
    'snips-home-campaign-page__hero relative'
  )
  const titleClass = classnames(
    {
      'snips-home-campaign-page__hero-body-title--active': IS_WEB
    },
    'mb3 bauta snips-home-campaign-page__hero-body-title'
  )
  return (
    <main className='snips-home-campaign-page main'>
      <Helmet
        script={[
          {
            innerHTML: `
          if (${IS_PROD} && !${IS_SANDBOX}) {
            !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
            n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
            document,'script','https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1190798517610794'); // Insert your pixel ID here.
            fbq('track', 'PageView');
          }
          `
          }
        ]}
      />
      <div className={heroClass}>
        <div className='snips-home-campaign-page__hero-background-wrap mx-auto'>
          <div className='snips-home-campaign-page__hero-background' />
        </div>
        <div className='snips-home-campaign-page__hero-body'>
          <div className='col-10 lg-col-12 mx-auto center'>
            <div className='mb3'>
              <div className={titleClass}>{title}</div>
              <div className='text-para'>Get notified when we launch!</div>
            </div>
            <EmailCollection
              label=''
              collectionConfig={emailCollectionConfig}
              afterSubmit={email => {
                // show thanks modal
                showModal(
                  <div>
                    <h1 className='mb2'>We’ll be in touch!</h1>
                    <p className='text-para'>
                      We’ll send out an email when we’re ready, to:
                      <br />
                      <br />
                      <code>{email}</code>
                    </p>
                  </div>
                )
                if (IS_PROD && !IS_SANDBOX && window.fbq) {
                  window.fbq('track', 'CompleteRegistration')
                }
              }}
              trackingLabel='snipsHomeCampaignPageCta'
            />
          </div>
        </div>
      </div>
      {showPrivacySection && (
        <PageSection extraClass='flex items-center justify-between white'>
          <div className='col-10 lg-col-12 mx-auto'>
            <Link
              className='snips-home-campaign-page__privacy-content white flex items-center justify-center'
              title='Private by Design'
              target='_blank'
              href='https://en.wikipedia.org/wiki/Privacy_by_design'
              onClick={() => {
                trackEvent('snipsHomeCampaignPagePrivacyByDesignLink')
              }}
            >
              <Icon className='icon icon--white mr2' icon='privacy-by-design' />
              <div>
                Private <br className='xs-hide sm-hide' />
                by Design
              </div>
            </Link>
          </div>
        </PageSection>
      )}
      <div className='center small white mb2 snips-home-campaign-page__footer'>
        &copy; {CURRENT_YEAR} Snips
      </div>
    </main>
  )
}

export default connect(null, { showModal })(SnipsHomeCampaignPage)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/SnipsHomeCampaignPage.js